"use client";

import React from "react";

import clsx from "clsx";
import { noop } from "lodash";

import { convertComponentProps } from "~/components/global-navigation/helpers/convert-component-props";
import { NavItemWithMeta } from "~/components/global-navigation/types";
import { useTouchDevice } from "~/hooks/use-touch-device";
import { useWindowScroll } from "~/hooks/use-window-scroll";

import { DESKTOP_GLOBAL_NAVIGATION_CLASSES, optionContentId } from "../constants";
import { OptionContent } from "../option-content/component";

import { DesktopGlobalNavigationDrawer } from "./styled";
import type { DesktopThirdLevelNavigationProps } from "./types";

export const DesktopThirdLevelNavigation: React.FC<
  DesktopThirdLevelNavigationProps
> = ({
  open,
  infoBannerHeight,
  offset,
  isInfoBannerClosed,
  categoriesRowOffset,
  isInfoBanner,
  navigation,
  activeCategoryIndex,
  activeOptionIndex,
  setActiveOptionIndex,
  viewAllLabel,
  onCloseOption,
}) => {
  const { scrollTop } = useWindowScroll();
  const isTouchDevice = useTouchDevice();

  if (activeCategoryIndex === null || activeCategoryIndex === undefined) {
    return;
  }

  const activeCategory = navigation?.[activeCategoryIndex];

  return (
    <DesktopGlobalNavigationDrawer
      classes={{
        paper: DESKTOP_GLOBAL_NAVIGATION_CLASSES.drawerContent,
      }}
      anchor="top"
      open={open}
      elevation={0}
      offset={offset}
      infoBannerOffset={infoBannerHeight}
      isInfoBannerClosed={isInfoBannerClosed}
      categoriesRowOffset={categoriesRowOffset}
      scrollTop={scrollTop}
      isInfoBanner={isInfoBanner}
    >
      {activeCategory?.children?.map((navItemElement, index) => (
        <OptionContent
          key={`${index}-${
            (navItemElement as NavItemWithMeta)?._meta?.deliveryId
          }-${optionContentId}`}
          className={clsx(
            DESKTOP_GLOBAL_NAVIGATION_CLASSES.floor,
            DESKTOP_GLOBAL_NAVIGATION_CLASSES.optionContent,
          )}
          navItem={convertComponentProps(navItemElement as NavItemWithMeta)}
          activeOption={activeOptionIndex === index}
          id={`${optionContentId}-${
            (navItemElement as NavItemWithMeta)?._meta?.deliveryId
          }`}
          onMouseLeave={isTouchDevice ? noop : onCloseOption}
          viewAllLabel={viewAllLabel || ""}
          setActiveOptionIndex={setActiveOptionIndex}
        />
      ))}
    </DesktopGlobalNavigationDrawer>
  );
};
